/**
 * Helps to trigger event also with enter
 * @param {callback} callback
 * @param {button} button triggering element
 */
export const clickEnterListener = (button, callback) => {
  const enterKeyCode = 13;

  button.addEventListener('click', callback);
  button.addEventListener('keydown', (event) => {
    if (event.keyCode === enterKeyCode) {
      callback();
    }
  });
};
